import { flatMap } from "lodash";
export default function getProgramServicesPayload(referrals) {
  return flatMap(referrals, function (_ref) {
    var service = _ref.service,
      programs = _ref.programs;
    return programs.map(function (p) {
      return {
        type: 'resource_list_program_service',
        relationships: {
          program: {
            data: {
              type: 'program',
              id: p.id
            }
          },
          service: {
            data: {
              type: 'service',
              id: service.id
            }
          }
        }
      };
    });
  });
}
//# sourceMappingURL=getProgramServicesPayload.js.map